'use strict';

const { normalizeSlug } = require('./slug');

/**
 * Optional one-off fixes: Strapi `slug` (left) → URL segment under /kampanja/ (right).
 * Page queries still use the normalized Strapi slug via `context.slug`; only the path changes.
 *
 * Add a row only when a slug was mistyped in CMS and you want a different URL segment.
 */
const CAMPAIGN_SLUG_PATH_ALIASES = Object.freeze({
  // Example: typoInStrapi: 'canonical-segment',
});

/**
 * @param {string|null|undefined} slug
 * @returns {string}
 */
function campaignUrlSegmentFromSlug(slug) {
  const s = normalizeSlug(slug);
  if (s === '') return '';
  return Object.prototype.hasOwnProperty.call(CAMPAIGN_SLUG_PATH_ALIASES, s)
    ? CAMPAIGN_SLUG_PATH_ALIASES[s]
    : s;
}

module.exports = {
  campaignUrlSegmentFromSlug,
  CAMPAIGN_SLUG_PATH_ALIASES,
};
